<template>
	<inertia-head title="SMS Mobile Number" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">SMS Mobile Number</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">SMS Mobile Number Report</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row justify-content-center">
			<div class="col-md-9">
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="form-group mb-3">
							<label>Member Status</label>
							<select v-model="form.member_status" class="form-select">
								<option value='active'>Active</option>
								<option value='in-active'>Inactive</option>
							</select>
						</div>
						<div class="form-group mb-3">
							<label>Date Range</label>
							<div class="input-group">
								<span>
									<flat-pickr
										v-model="form.start_date"
										:config="{
											enableTime: true,
											altInput: true,
											altFormat: 'M j, Y',
											dateFormat: 'Y-m-d',
										}"
										class="form-control"
										:class="
											form.errors.start_date
												? 'flatpickr-input is-invalid border-danger'
												: 'flatpickr-input'
										"
									/>
								</span>
								<span class="input-group-text">TO</span>
								<span>
									<flat-pickr
										v-model="form.end_date"
										:config="{
											enableTime: true,
											altInput: true,
											altFormat: 'M j, Y',
											dateFormat: 'Y-m-d',
										}"
										class="form-control"
										:class="
											form.errors.end_date
												? 'flatpickr-input is-invalid border-danger'
												: 'flatpickr-input'
										"
									/>
								</span>
							</div>
						</div>
						<div class="form-group mb-3">
							<label>Membership Level</label>
							<div class="form-check">
								<input @change="checkMember" type="checkbox" name="membership_level[]" class="form-check-input" checked="true" value="ALL" />ALL
							</div>
							<div class="form-check">
								<input type="checkbox" name="membership_level[]" class="form-check-input" value="SILVER" />SILVER
							</div>
							<div class="form-check">
								<input type="checkbox" name="membership_level[]" class="form-check-input" value="GOLD" />GOLD
							</div>
							<div class="form-check">
								<input type="checkbox" name="membership_level[]" class="form-check-input" value="DIAMOND" />DIAMOND
							</div>
							<div class="form-check">
								<input type="checkbox" name="membership_level[]" class="form-check-input" value="PLATINUM" />PLATINUM
							</div>
							<div class="form-check">
								<input type="checkbox" name="membership_level[]" class="form-check-input" value="PLATINUM COUPLE" />PLATINUM COUPLE
							</div>
						</div>
						<div class="form-group mt-5 text-center">
							<button @click="generateMobile" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-dark me-2"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-chart-line me-2"></i>
								<span>Generate</span>
							</button>
						</div>
					</div>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster';
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	layout: AuthLayout,
	props: {
		mobileData		: String,
		filters 	: Object
	},
	setup(props) {
		
		const form = useForm({
			member_status 		: 'active',
			start_date 			: new Date(),
			end_date 			: new Date(),
			membership_level 	: "ALL",
		})

		const checkMember = ()=>{
			let listOption = $("input[type='checkbox']:checked");
			let listOption1 = $("input[type='checkbox']");

			if($(listOption[0]).val()=='ALL')
			{
				for (let i = 1; i < listOption1.length; i++) {
					$(listOption1[i]).prop("checked",false);
					$(listOption1[i]).prop("disabled",true);
				}
			}else{
				for (let i = 1; i < listOption1.length; i++) {
					$(listOption1[i]).prop("disabled",false);
				}
			}
		}

		onMounted(()=>{
			checkMember();
		})

		const configMembership = (listOption)=>{
			for (let i = 0; i < listOption.length; i++) {
				let level = $(listOption[i]).val();
				if(i==0)
				{
					form.membership_level = level;
				}else{
					form.membership_level += ","+level;
				}
				
			}
		}

		const generateMobile = ()=>{

			let listOption = $("input[type='checkbox']:checked");

			configMembership(listOption);

			form.get(route('admin.reports.sms-number'),{
				preserveState: true,
				preserveScroll: true,
				only:['mobileData,filters'],
				onSuccess:()=>{
					let d 			= new Date();
				   	let file_name 	= "mobile_list_report_"+d.getFullYear()+d.getMonth()+d.getDate();
				   	let header 		= "application/csv";
				   	let data 		= props.mobileData;
				   	let blob 		= new Blob([data], {header});
				   	let url 		= window.URL.createObjectURL(blob);
				   	let link 		= document.createElement("a");

					file_name = file_name+".csv";
					
				    link.download = file_name;
				    link.href = url;
				    link.click();

					window.URL.revokeObjectURL(url);
				}
			})
		}
		
		return{
			form,
			checkMember,
			configMembership,
			generateMobile
		}
	},
}
</script>
